import { Injectable } from '@angular/core';

@Injectable()
export class SpotoviService {
  constructor() {}

  getSpotFrameRatesSettings() {
    return {
      additable: true,
      allFields: [this.getFrameRateSettings()],
      completerMainAndSecond: true,
      completerMainField: null,
      completerSecondField: null,
      deletable: true,
      details: [],
      documentType: 'Sifarnik',
      editable: true,
      fetchObject: 'basic',
      filterFields: [],
      formSettings: {
        header: [
          {
            title: 'Podaci',
            panels: [
              {
                title: 'Panel 1',
                panelVisible: false,
                expanded: true,
                controls: [[], []],
              },
            ],
          },
        ],
        table: [],
        lookupTable: [],
      },
      fromCode: '',
      group: 'Spot',
      idProperty: 'Id',
      inlineAdding: true,
      inlineEditing: true,
      lazyListSource: 'mainAndSecond',
      name: 'Spot',
      relations: [],
      title: 'Spot',
      type: 'spot',
      path: 'Spot',
      _id: '51073157',
    };
  }

  getFrameRateSettings() {
    return {
      additable: true,
      dbType: 'VARCHAR(25)',
      default: true,
      editable: false,
      fieldKey: 'FrameRate',
      entityType: 'SPOT_FRAME_RATES',
      id: '222-222-222',
      label: 'FrameRate',
      lookupFormCode: null,
      lookupFormName: null,
      mandatory: true,
      name: 'FrameRate',
      path: null,
      type: 'comboFixed',
      width: 10,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/services/spotovi.service.ts